"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tenantAuthSuccess = exports.tenantAuthSSO = exports.tenantAuthReset = exports.tenantAuthRefreshToken = exports.tenantAuthProfile = exports.tenantAuthLogout = exports.tenantAuthLogin = exports.tenantAuthGetUserLatestDetail = exports.tenantAuthError = void 0;
var _auth = require("./auth.constant");
// @flow

// common success
var tenantAuthSuccess = function tenantAuthSuccess(actionType, data) {
  return {
    type: _auth.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.tenantAuthSuccess = tenantAuthSuccess;
var tenantAuthError = function tenantAuthError(actionType, error) {
  return {
    type: _auth.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
exports.tenantAuthError = tenantAuthError;
var tenantAuthLogin = function tenantAuthLogin(username, password, recaptchaResponse, deviceId) {
  return {
    type: _auth.actionTypes.LOGIN,
    payload: {
      username: username,
      password: password,
      recaptchaResponse: recaptchaResponse,
      deviceId: deviceId
    }
  };
};

/*
 * logged in user details
 * @param payload
 * @returns api response
 * @description this function used to get logged in user's details.
 */
exports.tenantAuthLogin = tenantAuthLogin;
var tenantAuthProfile = function tenantAuthProfile() {
  return {
    type: _auth.actionTypes.DETAILS
  };
};

/**
 * Refresh Token
 * @param payload
 * @returns api response
 * @description this function used to refresh the existing access token.
 */
exports.tenantAuthProfile = tenantAuthProfile;
var tenantAuthRefreshToken = function tenantAuthRefreshToken(data) {
  return {
    type: _auth.actionTypes.REFRESH_TOKEN,
    payload: data
  };
};

/**
 * Logout
 * @returns api response
 * @description this function used to user logout.
 */
exports.tenantAuthRefreshToken = tenantAuthRefreshToken;
var tenantAuthLogout = function tenantAuthLogout() {
  return {
    type: _auth.actionTypes.LOGOUT
  };
};

/**
 * Reset tenantAuth
 * @param payload
 * @returns api response
 * @description this function used to reset tenantAuth.
 */
exports.tenantAuthLogout = tenantAuthLogout;
var tenantAuthReset = function tenantAuthReset() {
  return {
    type: _auth.actionTypes.RESET
  };
};

/**
 * SSO tenantAuth
 * @param payload
 * @returns api response
 * @description this function used to tenantAuthenticate sso login.
 */
exports.tenantAuthReset = tenantAuthReset;
var tenantAuthSSO = function tenantAuthSSO(data) {
  return {
    type: _auth.actionTypes.SSO,
    payload: data
  };
};

/**
 * SSO tenantAuth
 * @param payload
 * @returns api response
 * @description this function used to tenantAuthenticate sso login.
 */
exports.tenantAuthSSO = tenantAuthSSO;
var tenantAuthGetUserLatestDetail = function tenantAuthGetUserLatestDetail(data) {
  return {
    type: _auth.actionTypes.USER_LATEST_DETAIL,
    payload: data
  };
};
exports.tenantAuthGetUserLatestDetail = tenantAuthGetUserLatestDetail;